import Vue from 'vue';

function _addMultipleSearchTags(state, parentTag) {
  _removeOudatedChildTags(state, parentTag);

  parentTag.tags.forEach((tag) => {
    const existingTag = state.search.tags.find(t => t.key === tag.key);
    if (existingTag) {
      return;
    }
    state.search.tags.push(tag);
  });
}

function _addSearchTag(state, tag, performSearch) {
  // When it's not a pagination tag,
  // clear page
  if (!tag.page) {
    _removePageTag(state);
  }

  if (tag.isTerm) {
    const existingTag = state.search.tags.find(t => t.isTerm && t.text === tag.text);
    if (existingTag) {
      return;
    }
  } else {
    const existingTag = state.search.tags.find(t => t.key === tag.key);
    if (existingTag) {
      existingTag.tags = tag.tags;
      existingTag.text = tag.text;
      existingTag.value = tag.value;
      if (performSearch) {
        state.searchService.search();
      }
      return;
    }
  }

  state.searchService.addSearchTag(tag);

  if (tag.tags && tag.key !== 'wordCountRange') {
    _addMultipleSearchTags(state, tag);
  } else {
    state.search.tags.push(tag);
  }

  if (performSearch) {
    state.searchService.search();
  }
}

function _hasTagsWithParentKey(state, tag, parentKey) {
  if (tag.parentKey !== parentKey) {
    return false;
  }

  if (!tag.option || !tag.option.selected) {
    return false;
  }

  return !!state.search.tags.find(t => t.parentKey === parentKey);
}

function _removeAllSearchTags(state, performSearch) {
  // We keep hidden tags, they should be handled by the components
  const hiddenTags = state.search.tags.filter(t => t.hidden === true);
  state.searchService.clearSearchTags();
  Vue.set(state.search, 'tags', hiddenTags);

  if (performSearch) {
    state.searchService.search();
  }
}

function _removePageTag(state) {
  const pageTag = state.search.tags.find(t => t.page);
  if (!pageTag) {
    return;
  }

  _removeSearchTagFromList(state, pageTag);
  state.searchService.removeSearchTag(pageTag);
}

function _removeOudatedChildTags(state, parentTag) {
  const existingTags = state.search.tags.filter(t => t.parentKey === parentTag.key);
  existingTags.forEach((existingTag) => {
    const shouldKeep = parentTag.tags.find(t => t.key === existingTag.key);
    if (shouldKeep) {
      return;
    }

    const tagIndex = state.search.tags.findIndex(t => t.key === existingTag.key);
    state.search.tags.splice(tagIndex, 1);
  });
}

function _removeSearchTag(state, tag, performSearch) {
  if (!state.search.tags.length) {
    return;
  }

  const existingTags = state.search.tags.filter(t => t.key === tag.key || t.parentKey === tag.key);
  if (!existingTags.length) {
    return;
  }
  existingTags.forEach((existingTag) => {
    _removeSearchTagFromList(state, existingTag);
  });

  state.searchService.removeSearchTag(tag);

  // Formats and Genres search are triggered on d-books-search-form
  // If they exist, search is triggered automatically
  const hasFormatsTag = _hasTagsWithParentKey(state, tag, 'formats');
  const hasGenresTag = _hasTagsWithParentKey(state, tag, 'genres');

  if (hasFormatsTag || hasGenresTag) {
    return;
  }

  if (performSearch) {
    state.searchService.search();
  }
}

function _removeSearchTagFromList(state, tag) {
  // When it's not a pagination tag,
  // clear page
  if (!tag.page) {
    _removePageTag(state);
  }

  let tagIndex = state.search.tags.findIndex(t => t.key === tag.key);
  if (tagIndex === -1) {
    return;
  }

  state.search.tags.splice(tagIndex, 1);
}

let state;

const getters = {
  'get-displayed-search-tags':(state, getters, rootState) => {
    return state.search.tags.filter(t => !t.hidden);
  },
  'get-all-search-tags': (state, getters, rootState) => {
    return state.search.tags;
  },
};

const actions = {
  addSearchTag({ commit }, tag) {
    commit('addSearchTag', {
      tag: tag,
      performSearch: false,
    });
  },

  addSearchTagAndSearch({ commit }, tag) {
    commit('addSearchTag', {
      tag: tag,
      performSearch: true,
    });
  },

  clearSearchTags({ commit }) {
    commit('clearSearchTags');
  },

  removeSearchTag({ commit }, tag) {
    commit('removeSearchTag', tag);
  },
};

const mutations = {
  addSearchTag(state, searchTag) {
    _addSearchTag(state, searchTag.tag, searchTag.performSearch);
  },

  clearSearchTags(state, performSearch = true) {
    _removeAllSearchTags(state, performSearch);
  },

  removeSearchTag(state, tag, performSearch = true) {
    _removeSearchTag(state, tag, performSearch);
  },
};

export default class GenresStore {
  constructor(searchService) {
    state = {
      search: {
        tags: [],
      },
      searchService: searchService,
    };

    return {
      namespaced: true,
      state,
      getters,
      actions,
      mutations,
    };
  }
}
